import { TreeDiv, TreeSelectLocal } from 'components/TreeSelect/style'
import CrossIcon from 'components/icons/CrossIcon'
import SelectArrowIcon from 'components/icons/SelectArrowIcon'
import React from 'react'
const { SHOW_CHILD } = TreeSelectLocal

const TreeSelect = ({
  showSearch = false,
  treeData,
  treeCheckable = true,
  placeholder,
  onChange,
  height,
  width,
  placeholderSize,
  treeDefaultExpandAll = false,
  removeTreeIndent = false,
  shadowBox = false,
  disabled = false,
  showCheckedStrategy,
  removeIndent = false,
  valueParam = 'value', 
  titleParam = 'title',
  ...props
}) => {
  return (
    <TreeDiv id={'treeStyle'} removeIndent={removeIndent}>
      <TreeSelectLocal
        treeDefaultExpandAll={treeDefaultExpandAll}
        shadowBox={shadowBox}
        defaultExpandParent={true}
        showSearch={showSearch}
        treeData={treeData?.map(item => ({ ...item, value: item[valueParam], title: item[titleParam] }))} // Mapping valueParam and titleParam
        treeCheckable={treeCheckable}
        placeholder={placeholder}
        onChange={onChange}
        trigger={['click']}
        suffixIcon={<SelectArrowIcon />}
        removeIcon={<CrossIcon />}
        showCheckedStrategy={
           showCheckedStrategy || SHOW_CHILD
        }
        height={height}
        disabled={disabled}
        removeTreeIndent={removeTreeIndent}
        width={width}
        placeholderSize={placeholderSize}
        getPopupContainer={trigger => trigger.parentNode}
        dropdownStyle={{
          background: '#FFFFFF',
          border: '1px solid #EBECEE',
          boxShadow: '0px 2px 6px rgba(123, 97, 255, 0.15)',
          borderRadius: '10px',
        }}
        {...props}
      />
    </TreeDiv>
  )
}

export default TreeSelect
